import { ts } from '@/plugins/i18nFormat'

const missedResultsDef = ['DNC', 'DNS', 'DNF', 'TLE']

export type OtherResultOrderBehavior = 'preserve' | 'clear'

type OtherResultDef = {
    formula: string
    orderBehavior: OtherResultOrderBehavior
}

const otherResultsDef: Record<string, string | OtherResultDef> = {
    'DNC': 'boats + 1',
    'DNS': 'boats + 1',
    'OCS': 'boats + 1',
    'ZFP': 'Math.min( order + Math.ceil( 0.2 * ( boats + 1 ) * 10 ) / 10, boats + 1 )',
    'UFD': 'boats + 1',
    'BFD': 'boats + 1',
    'SCP': 'Math.min( order + Math.ceil( attr[percent|20] * ( boats + 1 ) * 10 ) / 10, boats + 1 )',
    'NSC': 'boats + 1',
    'DNF': 'boats + 1',
    'RET': 'boats + 1',
    'DSQ': 'boats + 1',
    'DNE': 'boats + 1',
    'RDG': {
        formula: 'Math.max( 1, Math.min( attr[points], boats + 1 ) )',
        orderBehavior: 'preserve',
    },
    'DPI': 'Math.min( order + attr[points], boats + 1 )',
    'STP': 'Math.min( order + attr[points], boats + 1 )',
    'TLE': 'boats + 1',
    'T1A': 'Math.min( order + Math.ceil( 0.3 * ( boats + 1 ) * 10 ) / 10, boats + 1 )',
}

export const individualLegendDef = {
    'ZFP': 'base + 20 % DNF = total',
    'SCP': 'base + attr % DNF = total',
    'RDG': 'total',
    'DPI': 'base + attr = total',
    'STP': 'base + attr = total',
    'T1A': 'base + 30 % DNF = total',
    'T1B': 'base + 30 % DNF = total', // temporary
}

export const implicitResult = 'DNC'

export const cannotBeDiscarded = ['DNE']

export const neverValidFinishes = ['DNC', 'DNS', 'DNF', 'TLE', 'NSC', 'OCS', 'UFD', 'BFD']

export const conditionallyValidFinishes = ['DSQ', 'DNE', 'RET']

export function otherResults() {
    return Object.keys(otherResultsDef).map(key => ({
        value: key,
        label: ts('otherResult-' + key),
        short: ts('otherResultShort-' + key),
    }))
        .sort((a, b) => (a.value.localeCompare(b.value)))
}

export function otherResultFormula(result: string): string | null {
    const def = otherResultsDef[result]

    if (def === undefined)
        return null

    return typeof def === 'string' ? def : def.formula
}

export function otherResultOrderBehavior(result: string): OtherResultOrderBehavior | null {
    const def = otherResultsDef[result]

    if (def === undefined)
        return null

    return typeof def === 'string' ? 'clear' : def.orderBehavior
}

export function missedResults() {
    return missedResultsDef.map(key => ({ value: key, label: ts('otherResult-' + key) }))
        .sort((a, b) => (a.value.localeCompare(b.value)))
}
